import JobTeaserOverviewDesktop from './partials/JobTeaserOverviewDesktop';
import JobTeaserOverviewMobile from './partials/JobTeaserOverviewMobile';
import useIsMobile from '~/hooks/useIsMobile';

/**
 * @param {JobTeaserOverviewProps} props
 */
const JobTeaserOverview = ({ teasers, format = 'TEASERS', isDarkMode }) => {
  const isMobile = useIsMobile({ contextKey: 'jobTeaser' });

  if (isMobile) {
    return (
      <JobTeaserOverviewMobile
        teasers={teasers}
        format={format}
        isDarkMode={isDarkMode}
      />
    );
  }
  return (
    <JobTeaserOverviewDesktop
      teasers={teasers}
      format={format}
      isDarkMode={isDarkMode}
    />
  );
};

export default JobTeaserOverview;
